import { NextImageProps } from '@/decodo/components/atoms/Image';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';

import { MainLinkItemProps } from './components/MainLinkItem';
import { Navigation } from './components/Navigation';
import './styles/native-navigation.css';

export type HeaderProps = {
  logoImage?: NextImageProps;
  logoLink: string;
  mainLinks: MainLinkItemProps['link'][];
  extraLinks: LinkButtonStrapiProps[];
  isRegionVisible: boolean;
};

export function Header({
  logoImage,
  logoLink,
  isRegionVisible,
  mainLinks,
  extraLinks,
}: HeaderProps) {
  return (
    <header className='light sticky top-0 z-50' id='header'>
      <LinkButton
        fullwidth
        color='primary'
        href='#main'
        classNames={{
          root: 'rounded-none focus-visible:outline-current absolute focus-visible:z-10',
        }}
      >
        Skip to main content
      </LinkButton>
      <div className='headerLg:py-0 bg-gray-dark-975 headerLg:px-10 relative z-[1] flex items-center justify-center px-5 py-4'>
        <Navigation
          logoImage={logoImage}
          logoUrl={logoLink}
          extraLinks={extraLinks}
          isRegionVisible={isRegionVisible}
          mainLinks={mainLinks}
        />
      </div>
    </header>
  );
}
